import { render, staticRenderFns } from "./modal-cart.vue?vue&type=template&id=18a9f7c0&"
import script from "./modal-cart.vue?vue&type=script&lang=js&"
export * from "./modal-cart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports